import * as React from 'react';
import { Form, Row, Col, Table, Button, Card, Icon, Tag, notification, Popover, Modal } from 'antd';
import {
  ICreditCardRegistrationDto,
  ConfirmCreditCardRegistrationRequestBody,
  AddressDto,
} from 'Core/Api/Payment/Api';
import CreditCardConfirmation from '../CreditCardConfirmation';
import { FormComponentProps } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router';
import { CreditCardRegistrationFormHandler } from '../CreditCardRegistrationFormHandler';
import AuthContext from 'Context/AuthContext';
import DeleteCreditCard from '../DeleteCreditCard';
import CardInfo from './CardInfo';
import CarRegistrationNotificationView, {
  CardRegistrationNotificationContent,
} from 'components/Payment/CardRegistrationNotificationView';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
  card(cardDetails2: Array<ICreditCardRegistrationDto>): any;
  getUpdateDetails(regId: number): any;
  chargeButton(regId: number): any;
  reloadList(): any;
  DisplayCardRegistrationForm(): any;
}

export interface State {
  cardDetails: Array<ICreditCardRegistrationDto>; //for list state
  confirmedClicked: boolean;
  showModal: boolean;
}

class BaseCreditCardRegisteredList extends React.Component<Props, State> {
  creditCardRegistrationFormHandler: CreditCardRegistrationFormHandler;
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  constructor(props: Props) {
    super(props);
    this.creditCardRegistrationFormHandler = new CreditCardRegistrationFormHandler(props);
    this.collectRegIdEdit = this.collectRegIdEdit.bind(this);
    this.collectCardDetails = this.collectCardDetails.bind(this);

    this.state = {
      cardDetails: [],
      confirmedClicked: false,
      showModal: false
    };
  }

  componentDidMount() {
    this.DisplayCreditCardList();
    // this.collectCardDetails();
  }

  DisplayCreditCardList = () => {
    // set user id and email address
    var userId;
    if (this.context.data) {
      userId = this.context.data.id!;
    }
    if (userId !== undefined) {
      this.creditCardRegistrationFormHandler
        .GetRegisteredCreditCard(userId)
        .then(details => {
          this.setState({ cardDetails: details });
          this.collectCardDetails();
        })
        .catch(() => { });
    }
  };

  // gets card details for card display componenet which passes
  // it on to other components that utilizes it
  collectCardDetails() {
    this.props.card(this.state.cardDetails);
  }

  // get card registration id for card update component via card display (parent)
  collectRegIdEdit(regId: number) {
    this.props.getUpdateDetails(regId);
  }



  render() {
    return (
      <>
        <Button onClick={() => this.setState({ showModal: true })} icon="question-circle" style={{ marginBottom: 5 }}>How Card Registration works</Button>
        <Modal visible={this.state.showModal} title="How Card Registration Works" closable={false} footer={[
          <Button onClick={() => this.setState({ showModal: false })}>Ok</Button>
        ]}>
          <CardRegistrationNotificationContent />
        </Modal>

        <Row>
          <Col>
            <Button type="primary" style={{ marginTop: 10, marginBottom: 10 }} onClick={this.props.DisplayCardRegistrationForm}>Register & Verify New Card</Button>
          </Col>
        </Row>

        {this.state.cardDetails.length > 0 ? (
          this.state.cardDetails.map(cardDetail => (
            <CardInfo
              key={cardDetail?.id ?? 0}
              cardDetails={cardDetail}
              editButton={this.collectRegIdEdit}
              reloadCardList={this.DisplayCreditCardList}
            />
          ))
        ) : (
          <>
            <p>No credit cards registered click to register one</p>

          </>
        )}
      </>
    );
  }
}

const CreditCardRegisteredListWithoutRouter = Form.create<Props>({
  name: 'UpdateUserProfileForm',
})(BaseCreditCardRegisteredList);

const CreditCardRegisteredList = withRouter(CreditCardRegisteredListWithoutRouter);

export default CreditCardRegisteredList;
